"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lapio": {
    "572c2b79": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "austelle": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cb69dc7a": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "campolapierto": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "065a21b3": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "campomarino": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "97ef79af": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "camposanto": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5ee14bfe": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "carpignano": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2fa95388": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "ferrume": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c07dbae": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "fratte": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bdab1a98": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "monticelle": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dbeb34ce": [{
      "hkey": "4e858d3d",
      "slug": "arianiello",
      "name": "Arianiello",
      "primary": true,
      "skipSearch": false
    }],
    "nuclei-abitati-arianiello": [{
      "hkey": "4e858d3d",
      "slug": "arianiello",
      "name": "Arianiello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "93b34b33": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "patierno": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6291c11": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a901191f": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola-matarola": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6631a564": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08dcb087": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "toppole": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "694f5080": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "skipSearch": false
    }],
    "vignedogniche": [{
      "hkey": "568a56f6",
      "slug": "lapio",
      "name": "Lapio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;